<template>
  <div class="part rank">
    <div class="part-title">&diams;<span class="inline-title">资源统计</span>
    <div class="switch-btns" v-show="false">
      <div class="btn" :class="{active: activeTab === '页数'}" @click="changeTab('页数')">页数</div>
      <div class="btn" :class="{active: activeTab === '册数'}" @click="changeTab('册数')">册数</div>
    </div></div>
    <div class="row">
      <div class="row-title">全部</div>
      <div class="row-bar" :style="{ width: 1 * ($isPhone ? 450 : 378) + 'px' }"></div>
      <div class="row-value">{{ numMax }}</div>
    </div>
    <div class="row" v-for="(item, index) in rankList" :key="index">
      <div class="row-title" @click="goTo(item)">{{ item.name }}</div>
      <div class="row-bar" :style="{ width: (item.num / numMax) * ($isPhone ? 450 : 378) + 'px' }"></div>
      <div class="row-value">{{ item.num }}</div>
    </div>
  </div>
</template>

<script>
import searchApi from '@/api/search.js'
import userActionsApi from '@/api/userActions.js'
export default {
  data () {
    return {
      rankList: [
      ],
      baseList: [],
      numMax: 1,
      countLimit: 9,
      activeTab: '册数'
    }
  },
  methods: {
    getData () {
      searchApi.selectBookStructureStatis().then(res => {
        // console.log(res)
        this.baseList = res;
        // if (this.baseList.length > this.countLimit) {
        //   this.baseList = this.baseList.slice(0, this.countLimit);
        // }
        this.changeTab('页数')
      })
    },
    changeTab (key) {
      this.activeTab = key
      const tempList = this.baseList.sort((a, b) => {
        const numA = this.activeTab === '册数' ? a.structureCount : a.pageCount;
        const numB = this.activeTab === '册数' ? b.structureCount : b.pageCount;
        return numB - numA;
      })
      this.rankList = tempList.slice(0, this.countLimit).map(item => {
        let obj = {}
        obj.bookId = item.bookId;
        obj.name = item.title.split('：')[0];
        obj.num = this.activeTab === '册数' ? item.structureCount : item.pageCount;
        obj.key = item.bookId;
        return obj
      })
      this.numMax = this.baseList.reduce((pre, cur) => {
        const num = this.activeTab === '册数' ? cur.structureCount : cur.pageCount;
        return pre + num;
      }, 0)
      if (this.numMax === 0) {
        this.numMax = 1;
      }
    },
    goTo (record) {
      this.addClickRecord(record);
      let url = window.location.origin + window.location.pathname
      this.$bus.$emit('openLogin', {
          url: `${url}#/detail?bookId=${record.bookId}`
      })
    },
    addClickRecord (item) {
      userActionsApi.addUserAction({
        actionCode: 'resourceClick',
        bookId: item.bookId,
        resourceId: item.id,
        resourceInfos: JSON.stringify(item)
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.rank {
  .row {
    display: flex;
    align-items: center;
    margin-top: 24px;

    .row-title {
      background-image: url("~@/assets/images/rank-title.png");
      background-size: 100% 100%;
      text-align: center;
      color: #4d4030;
      position: absolute;
      cursor: pointer;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .row-bar {
      height: 36px;
      background: linear-gradient(90deg, #f0cd85 0%, #ffa40f 100%);
      margin-left: 230px;
    }

    .row-value {
      color: #ffa40f;
      margin-left: 24px;
    }
  }
  .switch-btns {
      margin-left: 430px;
      border: 1px solid #7C1823;
      display: flex;
      border-radius: 4px;
      .btn {
        width: 56px;
        height: 30px;
        color: #707070;
        font-family: FangZhengKaiTi-GBK;
        .font-size-default;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &.active {
          color: #FFFFFF;
          background-color: #7C1823;
        }
      }
    }
}
// @media screen and (min-width: 769px) {
  .row-title {
    width: 245px;
    height: 44px;
    line-height: 44px;
    .font-size-large;
  }
  .row-value {
    .font-size-large;
  }

</style>
